<template>
  <div>
    <br class="hidden-xs-only">
    <div class="kongxi hidden-sm-and-up"></div>
    <el-card
      shadow="always"
      :body-style="{ padding: '20px' }"
    >
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/news' }">新闻动态</el-breadcrumb-item>
        <el-breadcrumb-item>新闻详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <h2>东进公司道滘镇病媒生物防制项目正式启动</h2>
        <div id="meta_content">
          <span class="rich_a">
            毕磊
          </span>
          <span class="rich_b">
            东进防控
          </span>
          <span id="rich_c">
            <span>2024-04-01 16:10</span>
            广东
          </span>
        </div>
        <p>
          【守护镇街健康，东进在行动】春回大地，万物复苏。在这个生机盎然的季节，为全面展开道滘镇病媒生物防制工作，确保各项措施得到有力执行，2024年4月1日上午9点，东进公司于道滘镇区举行道滘镇病媒生物防制项目启动仪式，道滘镇卫生健康局相关负责人吕凤萍出席此次活动。
        </p>
        <img
          width="100%"
          :src="img[0]"
          alt=""
        >
        <p>
          此次启动仪式的圆满完成，标志着东进公司在镇区公共卫生服务领域又迈出了坚实的一步。我们将以此为契机，持续推进镇街病媒生物防制迈上新台阶，提升公众对病媒生物危害的认识和防控意识，形成全民参与、共同防控的良好氛围。
        </p>
        <p>
          启动仪式结束后，镇区病媒生物防制工作正式拉开了序幕。公司专业消杀团队迅速行动，身着防护服，手持专业设备，对镇区的重点区域进行了全面、细致的消杀作业。他们严格按照操作规程，确保消杀工作的安全性和有效性。
        </p>
        <p>
          此次活动不仅为保障居民健康、创造宜居环境奠定了坚实基础，更是东进公司科学防控、绿色防控的生动实践。东进将以专业的技术、严谨的态度，全力以赴开展道滘镇病媒生物防制工作，以实际行动肩负起守护居民健康、营造宜居环境的重任。
        </p>
        <h3>我们还提供多元化服务</h3><img
          width="100%"
          :src="img[1]"
          alt=""
        >
        <h3>扫码关注我们了解更多</h3>
        <!-- <div class="big-div">
          <div class="small-div1">
            <img :src="img[4]" alt="">
            <div class="caption">时代东进 砥砺奋进</div>
          </div>
          <div class="small-div2">
            <img :src="img[5]" alt="">
            <div class="caption">www.tonking.com.cn <br>0769-22008298</div>
          </div>
        </div> -->
        <div>
          <img
            :src="img[2]"
            alt=""
          >
        </div>

      </div>
      <br>
      <br>
      <el-row :gutter="20">
        <el-col
          :span="12"
          :xs="24"
          :offset="0"
        >
          <span>&nbsp;</span>
        </el-col>
        <el-col
          :span="12"
          :xs="24"
          :offset="0"
          style="text-align: right"
          class="hidden-xs-only"
        >
          <span
            style="cursor: pointer; color: #666; font-size: 14px"
            @click="$router.push({ name: 'News10' })"
          >东进公司受邀参加黄江镇校园...&nbsp;&nbsp;&nbsp;&nbsp;下一条 &gt;</span>
        </el-col>

      </el-row>
      <br>
      <br>
    </el-card>
    <br class="hidden-xs-only">
    <div class="kongxi hidden-sm-and-up"></div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      img: [require('@/assets/news11.png'), require('@/assets/news8-4.png'), require('@/assets/news8-7.png')]
    }
  }
}
</script>

<style lang="scss" scoped>
.kongxi {
  height: 10px;
}

.big-div {
  display: flex;
  justify-content: space-evenly;
}

.small-div {
  text-align: center;
}

.small-div1 img {
  width: 258px;
  height: 258px;
}

.small-div2 img {
  width: auto;
  height: auto;
}

.caption {
  font-size: 14px;
  margin-top: 10px;
  text-align: center;
}

.content {
  width: 90%;
  margin: 0 auto;

  h2 {
    font-family: 黑体, SimHei;
    font-size: 24px;
    margin: 20px 0;
    text-align: center;
  }

  h3 {
    font-weight: normal;
    font-family: 黑体, SimHei;
    font-size: 18px;
    margin: 20px 0;
    text-align: left;
  }

  p {
    font-size: 16px;
    margin: 20px 0;
    text-align: justify;
    text-indent: 2em;
    color: #515050;
    font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
  }
}

.wenzi {
  margin: 0 !important;
  color: rgb(255, 255, 255) !important;
}

@media screen and (max-width: 768px) {
  .content {
    width: 90%;
    margin: 0 auto;

    h2 {
      margin: 20px 0;
      text-align: center;
      font-size: 24px;
    }

    h3 {
      font-size: 18px;
      margin: 20px 0;
      text-align: left;
    }

    p {
      margin: 10px 0;
      text-align: justify;
      text-indent: 2em;
      font-size: 16px;
      color: #515050;
      font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
    }
  }
}

#meta_content {
  font-size: 15px;
  padding-left: 2.6em;

  span {
    color: rgba(0, 0, 0, 0.3);
  }

  .rich_b {
    color: #576b95 !important;
  }
}
</style>
